import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import oliveBranch from '../../shared/assets/img/olive-branch.svg';
import onboardingRatingUser1 from '../../shared/assets/img/onboarding/OnBoardingRatingUser1.jpg';
import onboardingRatingUser2 from '../../shared/assets/img/onboarding/OnBoardingRatingUser2.jpg';
import { Button } from '../../shared/components/Button';
import { RatingStars } from '../../shared/components/RatingStars';
import { useLoggedInUserEdit } from '../../shared/hooks/useLoggedInUserEdit';
import { ROUTES } from '../../shared/routing/routes';
import { OnboardingProgress } from '../../types/obsessless-user';
import { TestimonialCard } from './components/TestimonialCard';
import { useOnboardingStore } from './hooks/useOnboardingStore';

const testimonials = [
    {
        name: 'Kelsey',
        title: 'Truly Amazing',
        review: 'This app is a game changer in between therapy sessions. It understands OCD and the various aspects of it so well!',
    },
    {
        name: 'Anna',
        title: 'Very Helpful for OCD!',
        review: 'This OCD App really helps with compulsions and intrusive thoughts! Ollies not only super cute but also very helpful!',
    },
    {
        name: 'Mark',
        title: 'Helped me a lot!',
        review: 'In all honesty, it\'s hard to beat an app like this. The amount of options given and how they\'re provided make it amazing.',
    },
    {
        name: 'Laura',
        title: 'Brilliant App',
        review: 'This app and my family\'s support helps me understand that I\'m not alone. I would highly recommend to anyone struggling!',
    },
];

export const OnboardingRating = () => {
    const navigate = useNavigate();
    const setCurrentStep = useOnboardingStore(state => state.setCurrentStep);
    const setTotalSteps = useOnboardingStore(state => state.setTotalSteps);
    const { saveOnboardingProgress } = useLoggedInUserEdit();

    useEffect(() => {
        setTotalSteps(16);
        setCurrentStep(2);
    }, [setCurrentStep]);

    const handleContinue = async () => {
        await saveOnboardingProgress(OnboardingProgress.GaveRating);
        navigate(ROUTES.onboarding.ocdCycleIntro);
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-full h-full flex flex-col items-center gap-6 safe-pb-4 flex-1 overflow-hidden">
            <title>Onboarding Rating</title>
            <div className='flex-shrink-0 flex flex-col gap-2 px-8'>
                <h1 className="text-osBlack text-[28px] font-bold text-center px-4">Best Rated OCD App</h1>
                <div className="flex items-center justify-center gap-1">
                    <img
                        src={oliveBranch}
                        alt="olive-branch"
                        className="h-[62px]"
                    />
                    <span className="text-osBlack text-[20px] font-semibold mt-1">4.8</span>
                    <RatingStars />
                    <img
                        src={oliveBranch}
                        alt="olive-branch"
                        className="h-[62px] scale-x-[-1]"
                    />
                </div>
            </div>
            <div className='flex-1 flex flex-col gap-6 px-8 py-4 overflow-auto'>
                <h1 className="text-osBlack text-[24px] font-bold text-center">ObsessLess was made
                    to help people like you</h1>
                <div className='flex flex-col items-center gap-1'>
                    <div className='flex justify-center'>
                        <img src={onboardingRatingUser1} alt="small-avatar-1" className='bg-osGrey-3 rounded-full w-18 h-18' />
                        <img src={onboardingRatingUser2} alt="small-avatar-2" className='bg-osGrey-3 rounded-full w-18 h-18 -ml-4' />
                        <span className='text-dark-pink text-[24px] bg-osPink-4 border-8 border-osPink-5 font-semibold rounded-full w-18 h-18 flex items-center justify-center -ml-4'>5k+</span>
                    </div>
                    <p className='font-sm'>5k+ ObsessLess Users</p>
                </div>
                <div className='flex flex-col gap-3'>
                    {testimonials.map((testimonial) => (
                        <TestimonialCard key={testimonial.name} name={testimonial.name} title={testimonial.title} review={testimonial.review} />
                    ))}
                </div>
            </div>
            <div className="flex-shrink-0 w-full px-8">
                <Button
                    label="That's great!"
                    onClick={handleContinue}
                />
            </div>
        </motion.div>
    );
};